import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { ColumnInputType } from '../column-input-type';
import { TableColumn } from '../table-column';
import { DateTimeHelperService } from '../../../shared/date-time-helper/date-time-helper.service';

@Pipe({
  name: 'cellData',
})
export class CellDataPipe implements PipeTransform {
  private dateTimeHelper: DateTimeHelperService = new DateTimeHelperService();

  transform(rowData: any, column: TableColumn, isEditDropdown: boolean = false): any {
    switch (column.inputType) {
      case ColumnInputType.DateTime:
        const dateTimeValue = _.get(rowData, column.valueField);
        return this.dateTimeHelper.isValidDateString(dateTimeValue) ?
          new Date(dateTimeValue).toISOString() :
          null;
      case ColumnInputType.Checkbox:
        const boolValue: any = _.get(rowData, column.valueField);
        if (boolValue == null) {
          return false;
        }
        return boolValue.toString().toLowerCase() === 'true';
      case ColumnInputType.Dropdown:
      case ColumnInputType.MultiDropdown:
        return isEditDropdown ? _.get(rowData, column.valueField) : _.get(rowData, column.labelField);
      case ColumnInputType.Text:
      default:
        return _.get(rowData, column.valueField);
    }
  }
}
